import { render, staticRenderFns } from "./garantie.vue?vue&type=template&id=cf1fa2e2&scoped=true"
import script from "./garantie.vue?vue&type=script&lang=ts"
export * from "./garantie.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf1fa2e2",
  null
  
)

export default component.exports